import React from "react";
import CommitteeMemberDetails from "./CommitteeMemberDetails";
import "../style/Committee.css";

function Committee() {
  const committeeOrder = [
    "chief-patron",
    "patron",
    "conference-advisory-board",
    "speakers",
    "convenor",
    "co-convenor",
    "organizing-committee",
    "student-coordinators",
    "technical-support",
    "logistics-and-transport",
  ];

  return (
    <div className="committee-section">
      <div className="committee-container">
        <h1>Committee Structure</h1>

        {committeeOrder.map((category, index) => (
          <div key={index} className="committee-direct-block">
            <CommitteeMemberDetails category={category} onBack={() => {}} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Committee;
